import React from 'react'

const Btn = (props) => (
    <a href={props.link} target="_blank" rel="noopener noreferrer" className="btn">
        {props.text}
    </a>
)

export default Btn